<div class="kpi-container">
    <div class="kpi-title">
        <h3>Key Performance Indicators</h3>
        <div class="middle-line"></div>
    </div>
    <div class="kpi-cards">
        <mat-card class="kpi-card">
            <div class="kpi-label">Avg Case Cycle Time - Last 90 days</div>
            <div class="kpi-value">
                <span>{{cycleTimeDays > 0 ? (cycleTimeDays + ' day' + (cycleTimeDays !== 1 ? 's' : '') + ' ') : ''}}{{cycleTimeHours}} hour{{cycleTimeHours !== 1 ? 's' : ''}}</span>
                <mat-icon *ngIf="totalAverageCycleTime > totalPreviousAverageCycleTime" class="red">arrow_upward</mat-icon>
                <mat-icon *ngIf="totalAverageCycleTime < totalPreviousAverageCycleTime" class="green">arrow_downward</mat-icon>
            </div>
        </mat-card>
        <mat-card class="kpi-card">
            <div class="kpi-label">Current Assigned Cases</div>
            <div class="kpi-value">
                <span>{{currentAssignedCases}} case{{currentAssignedCases !== 1 ? 's' : ''}}</span>
                <mat-icon class="grey">check_circle</mat-icon>
            </div>
        </mat-card>
    </div>
</div>